export function generateSrcSet(src: string) {
  return [32, 64, 128, 256, 512, 1024, 2048]
    .map(size => {
      return `${src}?width=${size} ${size}w`;
    })
    .join(", ");
}

export function generateOfferSrcSet(src: string) {
  return [512, 1024, 2048]
    .map(size => {
      return `${src}?width=${size} ${size}w`;
    })
    .join(", ");
}
